
export enum ArticleCancellationReason {
    ProductNotFound = 1,
}